import styled from 'styled-components';

export const WrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-itemes: flex-direction;
  justify-content: center;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 100%;
  }
`;

export const Spacer = styled.div`
  width: 100%;
  display: block;
  clear: both;
  height: 20px;
`;
